import { noop } from "lodash-es";
import { onMounted, ref } from "vue";

import { environment } from "@/utils/env/Environment";

export function useServicePopups() {
  const openServices = ref<() => void>(noop);
  const showServices = ref(false);

  onMounted(() => {
    const host = window.location.host;
    if (
      environment !== "production" &&
      (host.startsWith("piplanning.local") || host.startsWith("app.piplanning.local"))
    ) {
      showServices.value = true;
      const popups: Array<{ url: string; window?: Window | null }> = [
        { url: "https://api.piplanning.local" },
        { url: "https://nats.piplanning.local" },
        { url: "https://piplanning.local" },
      ];
      window.addEventListener("beforeunload", closeAll);

      let current = 0;
      setInterval(() => {
        if (popups[current].window?.closed) {
          if (current + 1 < popups.length) {
            open(current + 1);
          }
        }
      }, 500);

      openServices.value = () => {
        closeAll();
        open(0);
      };

      function open(index: number) {
        current = index;
        popups[current].window = window.open(popups[current].url, "nats", "width=1000,height=2000");
      }

      function closeAll() {
        popups.forEach((popup) => popup.window?.close());
      }
    }
  });

  return { showServices, openServices };
}
